<template>
  <div class="filtro-header-links">
    <!-- Loading state -->
    <a
      v-if="loading"
      data-testid="topbar-filter-loading-link"
      href="javascript:void(0)"
      class="filtro-header-link"
    >
      <i class="pi pi-spinner pi-spin"></i> 
      {{ t('Carregando filtro') }}
    </a>

    <!-- Filter info state -->
    <a 
      v-else
      id="btnFiltro"
      data-testid="topbar-filter-link"
      class="btnFiltroTopHeader filtro-header-link"
      href="javascript:void(0)"
      @click="openModal"
    >
      <!-- Mobile view - just icon -->
      <span class="visible-xs">
        <i class="pi pi-filter"></i>
      </span>

      <!-- Desktop view - full info -->
      <span class="hidden-xs">
        <span class="filter-info-item">
          <b>{{ t('Franquias selecionadas') }}:</b>
          <Tag :value="selectedFranchisesCount.toString()" severity="contrast" class="small-tag" />
        </span>
        
        <span class="filter-info-item">
          <i 
            v-if="showDateAlert" 
            class="pi pi-exclamation-triangle alert-icon"
          ></i>
          <b>{{ t('Período') }}:</b>
          <Tag :value="selectedPeriod" severity="contrast" class="small-tag" />
        </span>
      </span>
    </a>
  </div>
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { log } from '../../utils/DebugLogger';
import { useFiltro } from '../../composables/useFiltro';
import { eventBus } from '../../eventBus';

const emit = defineEmits<{
  'open-modal': [];
}>();

const { t } = useI18n();

const {
  loading,
  selectedFranchisesCount,
  selectedPeriod,
  showDateAlert
} = useFiltro();

const openModal = (): void => {
  log('FiltroHeaderLinks', 'openModal', 'Opening filter modal');
  emit('open-modal');
};

watch([loading, selectedFranchisesCount, selectedPeriod, showDateAlert], () => {
  log('FiltroHeaderLinks', 'watch', 'Filter state changed:', {
    selectedFranchisesCount: selectedFranchisesCount.value,
    selectedPeriod: selectedPeriod.value,
    showDateAlert: showDateAlert.value,
    loading: loading.value
  });
});

onMounted(() => {
  eventBus.on('filter.updated', () => {
    log('FiltroHeaderLinks', 'event:filter.ready', 'Received filter.ready event');
  });

  log('FiltroHeaderLinks', 'onMounted', 'Component mounted');
});

defineExpose({
  openModal
});
</script>

<style scoped>
.filtro-header-links {
  display: inline-block;
}

.filtro-header-link {
  display: inline-flex;
  align-items: center;
  color: #252729;
  padding: 15px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 4px;
}

.filtro-header-link:hover {
  text-decoration: none;
}

.btnFiltroTopHeader {
  transition: all 0.3s ease;
}

.btnFiltroTopHeader:hover {
  background-color: rgba(0, 0, 0, 0.08);
}

.filter-info-item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-right: 1.25rem;
}

.filter-info-item:last-child {
  margin-right: 0;
}

.alert-icon {
  color: #ef4444;
  margin-right: 0.25rem;
}

/* Small tag styling - penetrate into PrimeVue component */
:deep(.small-tag) {
  font-size: 0.75rem !important;
  padding: 0.125rem 0.5rem !important;
}

/* Mobile styles */
.visible-xs {
  display: none;
}

.hidden-xs {
  display: inline;
}

@media (max-width: 768px) {
  .visible-xs {
    display: inline;
  }
  
  .hidden-xs {
    display: none;
  }
}
</style>
